<template>
  <div id="app" scroll="no" style="overflow: hidden"
    v-bind:class="viewer? 'background-grey' : 'background-white'">
    <router-view/>
  </div>
</template>

<script>
export default {
  computed: {
    viewer () {
      return this.$store.getters.getViewer
    }
  }
}
</script>

<style>
#app {
  display: block;
  color: #2c3e50;
  background-size: 50%;
  font-family: 'Poppins', sans-serif;
  min-height: 100%;
  height: 100%;
}

.background-white {
 background-color: #F5F6FA !important;
}

.background-grey {
  background-color: #6B6B78 !important;
}
</style>
